module.exports = __webpack_public_path__ + "static/media/instagramLogo.72bf1611.png";